import axios from 'axios';
import { constructServiceURL } from '../../../../../../utils/URLTools';

const apiFetchBalanceOnHandRouteInfo = (payload) => {
  const serviceUrl = constructServiceURL({
    endpoint: 'getBalanceOnHandRouteInfo',
    stub: process.env.useStubbedEndpoints,
    pathParameters: {
      appContext: payload.appContext,
      impcCode: payload.params.impcCode,
    },
  });
  return axios.get(serviceUrl);
};

export default apiFetchBalanceOnHandRouteInfo;
